<!-- <app-navbar-style-one></app-navbar-style-one> -->

<div class="user-area">
    <div class="alert alert-danger" *ngIf="showError" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;"> <!--*ngIf="showError" -->
        {{errorMsg}}
    </div>
    <div class="alert alert-success" *ngIf="showSuccess" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;"> <!--*ngIf="showError" -->
        {{successMsg}}
    </div>
    <div class="container-fluid m-0">
        <div class="row align-items-center">
            <div class="col-lg-7 col-xl-6  p-0">
                <div class="user-img text-center">
                    <img src="../../../../assets/img/logo/logo.png" alt="Images">
                </div>
            </div>

            <div class="col-lg-5 col-xl-5">
                <div class="user-section text-center">
                    <div class="user-content">
                        <h2>مرحبا بك <b>في <a style="color: #000;" href="">وصلة</a></b></h2>
                    </div>
                    <div class="tab user-tab">
                        <ul class="tabs">
                            <li><a href="#"> <i class="flaticon-contact"></i> تسجيل الدخول</a></li>
                            <li><a href="#"> <i class="flaticon-verify"></i> إنشاء حساب</a></li>
                        </ul>
                        <div class="tab_content current active">
                            <div class="tabs_item current">
                                <div class="user-all-form">
                                    <div class="contact-form">
                                        <form [formGroup]="loginForm" id="loginForm">
                                            <div class="row">
                                                <div class="col-lg-12 ">
                                                    <div class="form-group">
                                                        <input type="text" name="phone" id="phone" class="form-control" formControlName="phone" placeholder="رقم الهاتف" (keypress)="validateNumber($event)">
                                                        <i class='bx bx-phone'></i>
                                                        <div *ngIf="f['phone'].touched && f['phone'].invalid" class="error-msg text-start">
                                                            <div *ngIf="f['phone'].hasError('required')">رقم الهاتف مطلوب</div>
                                                            <div *ngIf="f['phone'].hasError('pattern')">برجاء ادخال رقم هاتف صحيح</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12">
                                                    <div class="form-group">
                                                        <i class='bx bx-lock-alt'></i>
                                                        <input class="form-control" type="password" name="password" formControlName="password" placeholder="كلمة المرور">
                                                        <div *ngIf="f['password'].touched && f['password'].invalid" class="error-msg text-start">
                                                            <div *ngIf="f['password'].hasError('required')">كلمة المرور مطلوبة</div>
                                                            <div *ngIf="f['phone'].hasError('minLength')">كلمة المرور يجب ان تكون اطول من 8 احرف</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12 col-md-12 text-center">
                                                    <button type="submit" class="default-btn  user-all-btn" [disabled]="loading" (click)="login()">
                                                        <div *ngIf="loading" class="spinner-border text-light" role="status"></div>
                                                        تسجيل الدخول
                                                    </button>
                                                </div>
                                                <div class="col-lg-6 col-sm-6 form-condition">
                                                    <div class="agree-label">
                                                        <input type="checkbox" id="chb1">
                                                        <label for="chb1">تذكرني</label>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 col-sm-6">
                                                    <!-- <a class="forget" routerLink="/">هل نسيت كلمة المرور؟</a> -->
                                                </div>
                                            </div>
                                        </form>
                                        <!-- <div class="social-option">
                                            <h3>Or Login With</h3>
                                            <ul>
                                                <li><a href="#">Facebook</a></li>
                                                <li><a href="#">Twitter</a></li>
                                                <li><a href="#">Linkedin</a></li>
                                            </ul>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            
                            <div class="tabs_item">
                                <div class="user-all-form">
                                    <div class="contact-form">
                                        <form [formGroup]="registerForm" id="registerForm">
                                            <div class="row">
                                                <div class="col-lg-12 ">
                                                    <div class="form-group">
                                                        <i class='bx bx-user'></i>
                                                        <input type="text" name="name" id="name" class="form-control" formControlName="name" placeholder="الاسم بالكامل">
                                                        <div *ngIf="f2['name'].touched && f2['name'].invalid" class="error-msg text-start">
                                                            <div *ngIf="f2['name'].hasError('required')">الاسم مطلوب</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12 ">
                                                    <div class="form-group">
                                                        <input type="text" name="phone" id="phone1" class="form-control" formControlName="phone" placeholder="رقم الهاتف" (keypress)="validateNumber($event)">
                                                        <i class='bx bx-phone'></i>
                                                        <div *ngIf="f2['phone'].touched && f2['phone'].invalid" class="error-msg text-start">
                                                            <div *ngIf="f2['phone'].hasError('required')">رقم الهاتف مطلوب</div>
                                                            <div *ngIf="f2['phone'].hasError('pattern')">برجاء ادخال رقم هاتف صحيح</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12 ">
                                                    <div class="form-group">
                                                        <input type="text" name="sec_phone" id="secphone" class="form-control" formControlName="sec_phone" placeholder="رقم الهاتف الثاني" (keypress)="validateNumber($event)">
                                                        <i class='bx bx-phone'></i>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <div class="form-group">
                                                        <i class='flaticon-email-2'></i>
                                                        <input type="email" name="email" id="email" class="form-control" formControlName="email" placeholder="البريد الالكتروني">
                                                        <div *ngIf="f2['email'].touched && f2['email'].invalid" class="error-msg text-start">
                                                            <div *ngIf="f2['email'].hasError('required')">البريد الالكتروني مطلوب</div>
                                                            <div *ngIf="f2['email'].hasError('pattern')">برجاء ادخال بريد الكتروني صحيح</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12">
                                                    <div class="form-group">
                                                        <i class='bx bx-lock-alt'></i>
                                                        <input class="form-control" type="password" id="pass" name="password" formControlName="password" placeholder="كلمة المرور">
                                                        <div *ngIf="f2['password'].touched && f2['password'].invalid" class="error-msg text-start">
                                                            <div *ngIf="f2['password'].hasError('required')">كلمة المرور مطلوبة</div>
                                                            <div *ngIf="f2['password'].hasError('minLength')">كلمة المرور يجب ان تكون اطول من 8 احرف</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12">
                                                    <div class="form-group">
                                                        <i class='bx bx-lock-alt'></i>
                                                        <input class="form-control" type="password" id="confirmPass" name="password_confirmation" formControlName="password_confirmation" placeholder="تأكيد كلمة المرور">
                                                        <div *ngIf="f2['password_confirmation'].touched && f2['password_confirmation'].invalid" class="error-msg text-start">
                                                            <div *ngIf="f2['password_confirmation'].hasError('required')">كلمة المرور مطلوبة</div>
                                                            <div *ngIf="f2['password_confirmation'].hasError('minLength')">كلمة المرور يجب ان تكون اطول من 8 احرف</div>
                                                            <div *ngIf="f2['password_confirmation'].hasError('mismatch')">كلمة المرور يجب ان تكون مماثلة لكلمة المرور السابقة</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <div class="form-group">
                                                        <i class='flaticon-parking'></i>
                                                        <input type="text" name="city_id" id="city_id" class="form-control" formControlName="city_id" placeholder="المدينة">
                                                        <div *ngIf="f2['city_id'].touched && f2['city_id'].invalid" class="error-msg text-start">
                                                            <div *ngIf="f2['city_id'].hasError('required')">المدينة مطلوبة</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <div class="form-group">
                                                        <i class='flaticon-place'></i>
                                                        <input type="text" name="address" id="address" class="form-control" formControlName="address" placeholder="العنوان">
                                                        <div *ngIf="f2['address'].touched && f2['address'].invalid" class="error-msg text-start">
                                                            <div *ngIf="f2['address'].hasError('required')">العنوان مطلوب</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <div class="form-group">
                                                        <i class='flaticon-buildings'></i>
                                                        <input type="text" name="building" id="building" class="form-control" formControlName="building" placeholder="مبني">
                                                        <div *ngIf="f2['building'].touched && f2['building'].invalid" class="error-msg text-start">
                                                            <div *ngIf="f2['building'].hasError('required')">المبني مطلوب</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <div class="form-group">
                                                        <i class='flaticon-workflow'></i>
                                                        <input type="text" name="floor" id="floor" class="form-control" formControlName="floor" placeholder="الطابق">
                                                        <div *ngIf="f2['floor'].touched && f2['floor'].invalid" class="error-msg text-start">
                                                            <div *ngIf="f2['floor'].hasError('required')">الطابق مطلوب</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <div class="form-group">
                                                        <i class='flaticon-event'></i>
                                                        <input type="text" name="flat" id="flat" class="form-control" formControlName="flat" placeholder="الشقة">
                                                        <div *ngIf="f2['flat'].touched && f2['flat'].invalid" class="error-msg text-start">
                                                            <div *ngIf="f2['flat'].hasError('required')">الشقة مطلوبة</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <div class="form-group">
                                                        <i class='flaticon-position'></i>
                                                        <input type="text" name="special_mark" id="special_mark" class="form-control" formControlName="special_mark" placeholder="علامة مميزة">
                                                        <div *ngIf="f2['special_mark'].touched && f2['special_mark'].invalid" class="error-msg text-start">
                                                            <div *ngIf="f2['special_mark'].hasError('required')">العلامة المميزة مطلوبة</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <div class="form-group text-start">
                                                        <p>
                                                            <input type="radio" id="male" name="gender" value="male" (click)="changeGenderValue('male')">
                                                            <label for="male"> ذكر</label>
                                                        </p>
                                                        <p>
                                                            <input type="radio" id="female" name="gender" value="female" (click)="changeGenderValue('female')">
                                                            <label for="female"> إنثي</label>
                                                        </p>
                                                        <!-- <i class='flaticon-email-2'></i>
                                                        <input type="email" name="email" id="email" class="form-control" formControlName="email" placeholder="البريد الالكتروني">
                                                        <div *ngIf="f['phone'].touched && f['phone'].invalid" class="error-msg text-start">
                                                            <div *ngIf="f['phone'].hasError('required')">رقم الهاتف مطلوب</div>
                                                            <div *ngIf="f['phone'].hasError('pattern')">برجاء ادخال رقم هاتف صحيح</div>
                                                        </div> -->
                                                    </div>
                                                </div>
                                                <!-- <div class="col-12">
                                                    <div class="form-group">
                                                        <i class='bx bx-lock-alt'></i>
                                                        <input class="form-control" type="password" name="password" placeholder="Password">
                                                    </div>
                                                </div> -->
                                                <div class="col-lg-12 col-md-12 text-center"> 
                                                    <button type="submit" class="default-btn user-all-btn" [disabled]="loading" (click)="signUp()">
                                                        <div *ngIf="loading" class="spinner-border text-light" role="status"></div>
                                                        إنشاء حساب 
                                                    </button>
                                                </div>
                                                <!-- <div class="col-12">
                                                    <p class="account-desc">هل لديك حساب بالفعل؟ <a routerLink="/">تسجيل الدخول</a></p>
                                                </div> -->
                                            </div>
                                        </form>
                                        <!-- <div class="social-option">
                                            <h3>Or Register With</h3>
                                            <ul>
                                                <li><a href="#">Facebook</a></li>
                                                <li><a href="#">Twitter</a></li>
                                                <li><a href="#">Linkdin</a></li>
                                            </ul>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Add this modal to your template -->
<div *ngIf="showOtpModal" class="otp-modal-overlay">
  <div class="otp-modal">
    <div class="otp-modal-header">
      <h3>تفعيل الحساب</h3>
      <button class="close-btn" (click)="closeOtpModal()">×</button>
    </div>
    
    <div class="otp-modal-body">
      <p class="otp-instruction">تم إرسال كود التفعيل المكون من 6 أرقام إلى بريدك الإلكتروني</p>
      
      <div class="otp-inputs-container">
        <div *ngFor="let digit of [0,1,2,3,4,5]; let i = index" class="otp-input-wrapper">
          <input
            [id]="'otp-' + i"
            type="text"
            maxlength="1"
            class="otp-input"
            (input)="onOtpInput($event, i)"
            (keydown)="onOtpKeyDown($event, i)"
            [value]="otp[i]"
            autocomplete="one-time-code"
          >
        </div>
      </div>
      
      <div class="otp-timer">
        <span *ngIf="!isResendEnabled" class="timer-text">
          إعادة الإرسال بعد: {{ otpCountdown }} ثانية
        </span>
        <button 
          *ngIf="isResendEnabled" 
          class="resend-btn"
          (click)="resendOtp()"
        >
          إعادة إرسال الكود
        </button>
      </div>
    </div>
    
    <div class="otp-modal-footer">
      <button class="default-btn user-all-btn" (click)="verifyOtp()">تفعيل الحساب</button>
    </div>
  </div>
</div>

<!-- Success/Error Messages -->
<div *ngIf="showSuccessOTP" class="alert alert-success" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;">
  {{ successMsgOTP }}
</div>

<div *ngIf="showError" class="alert alert-danger" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;">
  {{ errorMsg }}
</div>